

























import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import About from '@/components/company/About.vue';
import Insurance from '@/components/company/Insurance.vue';
import PaymentTerms from '@/components/company/PaymentTerms.vue';
import NotificationSetting from '@/components/company/NotificationSetting.vue';

// Types
import { CustomerOrganizationFields } from '@/types/graphql/schemaTypes';

@Component({
  components: {
    About,
    Insurance,
    NotificationSetting,
    PaymentTerms
  }
})
export default class Detail extends Vue {
  @Prop({ required: true })
  private customerOrganization!: CustomerOrganizationFields;
}
